import {useContext, useEffect, useState} from 'react';
import {call, getContext, put, setContext} from 'redux-saga/effects';
import {END} from 'redux-saga';

import {setterChannel} from '../utils/channels';
import {AppContext} from './index';

let nextKey = 1;
function getNextKey() {
    const result = nextKey.toString();
    nextKey++;
    return result;
}

export function feedbackChannel(setter) {
    let busy = 0;
    let error = null;
    return setterChannel((message) => {
        if (message === END) {
            return;
        }
        if ('busy' in message) {
            if (message.busy) {
                busy++;
            } else {
                busy--;
            }
        }
        if ('error' in message) {
            error = message.error;
        }
        setter({ busy: busy > 0, error });
    });
}

export function useFeedback(visual=false) {
    const [key] = useState(getNextKey);
    const [{busy, error}, setFeedback] = useState({ busy: false, error: null });
    const { mergeFeedback } = useContext(AppContext);
    const [feedbackCh] = useState(() => feedbackChannel((value) => {
        setFeedback(value);
        mergeFeedback?.(key, { ...value, visual });
    }));
    useEffect(() => {
        return () => {
            feedbackCh.close();
            mergeFeedback?.(key, null);
        };
    }, [feedbackCh, key, mergeFeedback]);
    return {busy, error, feedbackCh, channel: feedbackCh};
}

export function* withFeedbackChannel(channel, saga, ...args) {
    yield setContext({feedback: channel});
    return yield call(saga, ...args);
}

function* putFeedbackSaga(value) {
    const channel = yield getContext('feedback');
    if (channel) {
        yield put(channel, value);
    }
}

export function putFeedback(value) {
    return call(putFeedbackSaga, value);
}
